/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './customer-care-executive.reducer';

export const CustomerCareExecutiveDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const customerCareExecutiveEntity = useAppSelector(state => state.customerCareExecutive.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="customerCareExecutiveDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.customerCareExecutive.detail.title">CustomerCareExecutive</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.customerCareExecutive.id">Id</Translate>
            </span>
          </dt>
          <dd>{customerCareExecutiveEntity.id}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.customerCareExecutive.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{customerCareExecutiveEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.customerCareExecutive.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{customerCareExecutiveEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.customerCareExecutive.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{customerCareExecutiveEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.customerCareExecutive.active">Active</Translate>
            </span>
          </dt>
          <dd>{customerCareExecutiveEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.customerCareExecutive.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{customerCareExecutiveEntity.cursor}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.customerCareExecutive.name">Name</Translate>
            </span>
          </dt>
          <dd>{customerCareExecutiveEntity.name}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="tinyMedicRestApp.customerCareExecutive.email">Email</Translate>
            </span>
          </dt>
          <dd>{customerCareExecutiveEntity.email}</dd>
          <dt>
            <span id="gender">
              <Translate contentKey="tinyMedicRestApp.customerCareExecutive.gender">Gender</Translate>
            </span>
          </dt>
          <dd>{customerCareExecutiveEntity.gender}</dd>
          <dt>
            <span id="mobile">
              <Translate contentKey="tinyMedicRestApp.customerCareExecutive.mobile">Mobile</Translate>
            </span>
          </dt>
          <dd>{customerCareExecutiveEntity.mobile}</dd>
          <dt>
            <span id="dateOfBirth">
              <Translate contentKey="tinyMedicRestApp.customerCareExecutive.dateOfBirth">Date Of Birth</Translate>
            </span>
          </dt>
          <dd>{customerCareExecutiveEntity.dateOfBirth}</dd>
          <dt>
            <span id="bloodGroup">
              <Translate contentKey="tinyMedicRestApp.customerCareExecutive.bloodGroup">Blood Group</Translate>
            </span>
          </dt>
          <dd>{customerCareExecutiveEntity.bloodGroup}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.customerCareExecutive.contactCode">Contact Code</Translate>
          </dt>
          <dd>{customerCareExecutiveEntity.contactCode ? customerCareExecutiveEntity.contactCode.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.customerCareExecutive.user">User</Translate>
          </dt>
          <dd>{customerCareExecutiveEntity.user ? customerCareExecutiveEntity.user.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/customer-care-executive" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/customer-care-executive/${customerCareExecutiveEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CustomerCareExecutiveDetail;
